import { useEffect, useState } from 'react'

import { useHealth } from '../../hooks/queries'
import { naechsterStartAusDemNetz } from '../../lib/huelle'
import { useTexte } from '../../texte'

/**
 * Wacht darüber, dass der Browser dieselbe Version fährt wie der Server.
 *
 * Der Anlass war ein handfester Fehler: auf dem iPad hing eine alte Hülle im
 * Zwischenspeicher, und weil ein FTP-Upload die alten Dateien nicht wegräumt,
 * lud sie klaglos weiter eine alte Releaseversion. Der Server war aktuell, das Gerät
 * nicht — und eine gerade eingebaute Sperre wirkte dort schlicht nicht.
 * Unbemerkt, denn nichts sah kaputt aus.
 *
 * **Since 1.79.0 this watch is the lock that matters**: the service worker
 * hands out the stored shell at once, so that a start in a dead spot is not a
 * white screen, and after a release that shell is the old one. The watch
 * compares the built-in version with what `/api/health` says and on a
 * difference reloads **once** -- once per server version, remembered in
 * `sessionStorage`; without that marker a loop would be possible, and an app
 * that reloads every two seconds is worse than an outdated one. Before the
 * reload it asks the worker to take that navigation from the net
 * (`naechsterStartAusDemNetz()`).
 *
 * If it is still different afterwards, only a human can help: then it says so.
 */
export function StandWache() {
  const t = useTexte().rahmen
  const health = useHealth(true)
  const server = health.data?.build
  const [veraltet, setVeraltet] = useState(false)

  useEffect(() => {
    // Im Entwicklungsbetrieb trägt die Releaseversion keinen Commit -- da wäre
    // jeder Vergleich ein Fehlalarm.
    if (!server || __BUILD__ === 'dev' || server === __BUILD__) {
      return
    }

    const marke = `tb-neu-geladen-${server}`
    if (sessionStorage.getItem(marke) !== null) {
      setVeraltet(true)
      return
    }

    sessionStorage.setItem(marke, '1')
    // The worker hands out the stored shell at once (1.79.0); after a release
    // that is the old one. The marker makes this one reload fetch the new
    // shell from the net -- otherwise it would get the old one again, and the
    // notice below would stand there after every release.
    void naechsterStartAusDemNetz().then(() => window.location.reload())
  }, [server])

  if (!veraltet) {
    return null
  }

  return (
    <div className="stand-wache" role="status">
      {t.veraltet(__BUILD__, server ?? '')}
    </div>
  )
}
